// frontend_react/src/services/authApi.js

import api from "./api";

export const login = ({ email, username, password }) =>
  api.post("/auth/login", { email, username, password });

export const clientLogin = ({ username, email, password }) =>
  api.post("/auth/login/client", { username, email, password });

export const logout = () =>
  api.post("/auth/logout");

export const refreshToken = () =>
  api.post("/auth/refresh");

export const fetchCurrentUser = () =>
  api.get("/auth/current_user");

// Alias lisible pour le chantier multi-company
export const fetchAuthenticatedUser = fetchCurrentUser;

export const forgotPassword = (payload) =>
  api.post("/auth/forgot-password", payload);

export const forgotPasswordClient = (payload) =>
  api.post("/auth/forgot-password/client", payload);

export const resetPassword = (token, payload) =>
  api.post(`/auth/reset-password/${encodeURIComponent(token)}`, payload);

export const resetPasswordClient = (token, payload) =>
  api.post(
    `/auth/reset-password/client/${encodeURIComponent(token)}`,
    payload
  );

export const phoneLogin = (payload) =>
  api.post("/auth/phone-login", payload);

export const phoneVerify = ({ phone, code }) =>
  api.post("/auth/phone-verify", { phone, code });

export const uploadProfilePicture = (formData) =>
  api.post("/auth/profile-picture", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

export const verifyPassword = (password) =>
  api.post("/auth/verify-password", { password });